import { lazy } from "react";
// ===========================================================================
// Patient Geography Module — georreferenciación de pacientes.
//
// Mapa de burbujas por ZIP con la distancia de cada paciente a su centro
// asignado, y la distinción accionable del módulo: reasignables (hay otro
// centro más cerca) vs. aislados (viven lejos de todo → telehealth/outreach).
//
// Backend: api/geography (docs/modulos/GeoSistem/10_ENDPOINTS_GEOGRAPHY.md).
// Diseño:  docs/modulos/GeoSistem/UIUX_GEOGRAFIA_PACIENTES.md.
//
// ACCESO: lo gobierna la matriz RBAC y NADA MÁS — módulo `patient_geography`
// (38) del catálogo, mapeado en app/AccessDenied/roleRoutePermissions.js.
//
// 2026-08-31: se retiró `GeographyGuardedRoute`, que exigía ADEMÁS estar en la
// allowlist de empleados (REACT_APP_GEOGRAPHY_EMPLOYEES). Mientras el módulo no
// estaba en el catálogo esa lista era el único control posible, pero al
// registrarse pasó a ser un segundo gate invisible: conceder el módulo desde
// Access Control no alcanzaba y el usuario caía en /AccessDenied sin
// explicación. Mismo arreglo que Pre-Visit Planning, misma causa.
//
// Lazy obligatorio: Leaflet pesa y no debe viajar en el bundle inicial.
// ===========================================================================
const PatientGeographyPage = lazy(() => import("./pages/PatientGeographyPage"));

export const patientGeographyRoutes = [
  { path: "/patient-geography", element: <PatientGeographyPage /> },
];

// Utilidades públicas del módulo (colores de banda, formato de distancias).
export * from "./common/constants";
